// src/components/EspaciosPublicos.jsx
import React, { useRef, useState, useEffect } from 'react';
import '../styles/stylesEspaciosPublicos.css';

const espacios = [
  {
    id: 1,
    titulo: 'Cristo de la hermandad',
    imagen: '/resources/cristo.jpg',
      imagenes: ['/resources/cristoParedes.webp'
      ],
      descripcion: {
        intro: 'Se emplaza en el acceso a la localidad sobre la Ruta 301-S; es una escultura tallada en madera y rodeada por las estaciones del “Vía Crucis”. La pieza que moldeó el escultor chileno Luis Sissara fue extraída de un eucalipto colorado de 80 años, tomado de la estancia “La Atalaya”, ubicada en la zona rural de la localidad y la que fuera propiedad de Don Pedro Bernasconi. El espacio cuenta con plantaciones de árboles y un edificio que cuenta con un pabellón sanitario unisex, cocina y salón de usos múltiples'
      }
  },
  {
    id: 2,
    titulo: 'Instituciones educativas',
    imagen: '/resources/escuela.png',
    imagenes: ['/resources/jardin.webp',
               '/resources/ferrocarril.png'],    // Imágenes extra (opcional)
    descripcion: {
      intro: 'La localidad cuenta con instituciones que brindan acceso a todos los niveles de educación (inicial, primario, secundario y terciario); a saber:',
      items: [
    'Jardín de Infantes N° 8160 “Rosa de Sraier”: brindando educación a las primeras infancias, contando con sala de 3, 4 y 5 años. Está ubicado en la intersección de las calles Belgrano y Güemes; es un espacio muy valioso para nuestra comunidad.',
    'Escuela Primaria N° 349 “J. de San Martín”: brinda la educación de nivel primario para todos los niños de la localidad y zona rural, siendo accesible para todos ellos ya que se encuentra en el centro del pueblo.',
    'Escuela de Educación Secundaria Particular Incorporada N° 2047 “Los Colonizadores”: institución abocada a la educación secundaria, brindando la posibilidad de internado para varones; acogiendo a alumnos de la localidad y zonas aledañas.',
    'Instituto Superior Particular Incorporado N° 4023 “Los Colonizadores”: es un importante referente de la educación de nivel superior en la zona, posibilitando la formación académica de docentes y técnicos; brindando oportunidades de estudio que beneficien el desempeño laboral de los mismos.'
  ] 
    }
  },
  {
    id: 3,
    titulo: 'Plaza "San Martín"',
    imagen: '/resources/plaza.jpg',
      imagenes: ['/resources/plaza2.webp',
               '/resources/plaza3.webp',
              '/resources/plaza4.webp'],  
    descripcion:{ 
      intro:  'Se ubica en el centro del ejido urbano, deja apreciar frondosos árboles de distintas especies. Rodeando a la fuente central se hallan las esculturas de madera realizadas bajo el lema “Hacia nuestras raíces”, talladas en madera y representando figuras de la cultura local como: un niño pescador, la leyenda de Anahí, el chacarero y la Laguna La Sorda. Asimismo, se observan juegos para los niños y un área de servicios (agua caliente, wifi). '
    }
    },
    {
    id: 4,
    titulo: 'Museo "Santo Domingo y Sarita"',
    imagen: '/resources/museo.webp',
    descripcion:{intro: 'Es un espacio físico donde se atesora la historia de los habitantes de la localidad, generando espacios de reflexión y el conocimiento de nuestro patrimonio y cultura. Funciona en la vivienda cedida por la familia de Hugo Mozzati perteneciente a Nicanor Antuña (familia materna).'}
  },
  {
    id: 5,
    titulo: 'Centro cívico',
    imagen: '/resources/comuna.jpg',
    descripcion:{
      intro:  'Conformado por los edificios de la Comuna, el Juzgado de Paz y la Subcomisaría Octava: Ubicados frente a la Plaza San Martín, estas instituciones forman parte de la historia de la localidad. El 21 de setiembre de 1973 se inauguró el edificio que albergó por años a la Comuna, la subcomisaría y el Juzgado de Paz. Ante el crecimiento de la localidad, surgió la necesidad de planificar un nuevo edificio para la Comuna; el mismo se proyectó en la misma cuadra y fue inaugurado el 5 de diciembre de 2003; quedando de esta forma el antiguo lugar destinado a las oficinas del Juzgado de Paz y la Administración Provincial de Impuestos (este espacio hoy se utiliza como área para realizar trámites de IAPOS y Estafeta Postal). '
    }
  },
  {
    id: 6,
    titulo: 'Grupo escultórico “Los Inmigrantes” y “Cruz Ecuménica”',
    imagen: '/resources/inmigrantes.webp',
      imagenes: ['/resources/inmigrantes2.webp',
               '/resources/inmigrantes4.webp',
              '/resources/inmigrantes3.webp',
            '/resources/inmigrantes5.jpg'],
      descripcion:{
        intro:'Se hallan al ingresar al pueblo, recibiendo a todos los visitantes de la localidad. El grupo escultórico fue realizado en honor a los primeros habitantes de la localidad y la Cruz se emplaza al inicio de la avenida Santa Fe (que bordea el límite sur de la zona urbana), construida en oportunidad de conmemorarse los cien años de la fundación. Su mensaje representa el esfuerzo de los habitantes para que el pueblo sea lo que es hoy.'
      }
  },  
  {
    id: 7,
    titulo: 'Instituciones Religiosas',
    imagen: '/resources/capilla.webp',
    imagenes: ['/resources/temploVision.png',
               '/resources/evangelica.png'],    // Imágenes extra (opcional)
    descripcion: {
      intro: 'Los habitantes de Santo Domingo, en su mayoría, profesan el cristianismo; siendo feligreses de la Iglesia Católica, la Iglesia Evangélica del Río de la Plata y el Templo Visión de Futuro; dando cuenta de las creencias religiosas de los inmigrantes que llegaron a la región y las tradiciones que transmitieron a sus pobladores actuales.',
    }
  },
  {
    id: 8,
    titulo: 'Instituciones deportivas:',
    imagen: '/resources/Union.jpg',
    descripcion: {
      intro: 'Los clubes son espacios de deporte, encuentro, recreación y diversión. La localidad cuenta con dos lugares destinados a poder llevar a cabo estas actividades; uno en el sector oeste y el otro en el centro: el “Centro Cultural, Recreativo y Deportivo Unión” y el “Football Club Juventud Unida”. Ambos permiten realizar variados deportes y eventos sociales para todas las edades.',
    }
  },
  {
    id: 9,
    titulo: 'Biblioteca',
    imagen: '/resources/biblioteca.png',
    descripcion: {
      intro: 'La Biblioteca Popular “Domingo Faustino Sarmiento”, se encuentra muy cerca de la plaza central; permite acceder a talleres culturales, donde las palabras escritas cobran vida y cuentan grandes historias que llegan a las manos de adultos, jóvenes y niños de la localidad.',
    }
  },
  {
    id: 10,
    titulo: 'Instituciones de Salud',
    imagen: '/resources/samco.webp',
      imagenes: ['/resources/jacaranda.png'],
    descripcion: {
      intro: '',
      items: [
    ' SAMCo: es el Ex - Hospital Rural N° 24; el espacio de salud por referencia, brinda atención primaria de la salud de los pobladores locales como también de pueblos vecinos. Cuenta con servicios de medicina general, enfermería, radiología, kinesiología, odontología, ecografía, guardias médicas y traslado de ambulancia.',
    ' Centro de Día “El Jacarandá”: espacio destinado a la atención y contención de jóvenes y adultos con discapacidad, fundado en el año 2002, contando con un edificio propio desde el año 2005. Cumple una importante función social para asistentes de la localidad como de pueblos cercanos. Se encuentra a cargo de la Asociación del Centro de Día.',
    ' Hogar de Ancianos “8 de Agosto”: una institución muy ansiada para toda la comunidad, permite el alojamiento de personas mayores, fue inaugurado en el año 2022 y brinda asistencia a …….de la localidad; estando en construcción una sala para ampliar la oferta de atención.',
    ' Centro de Jubilados y Pensionados, se halla en el área noroeste, siendo un espacio donde los adultos mayores pueden realizar diversidad de talleres y actividades, disfrutando del tiempo de ocio y de los cuidados necesarios para sostener una vejez con calidad de vida.'
  ] 
    }
  },
  {
    id: 11,
    titulo: 'Corredor biológico de “La Colonización”',
    imagen: '/resources/malvinas.png',
    imagenes: ['/resources/corredorb1.jpg',
      '/resources/corredorb2.jpg',
      '/resources/corredorb3.jpg',
      '/resources/corredorb4.jpg',
      '/resources/corredorb5.jpg',
      '/resources/corredorb6.jpg',
      '/resources/corredorb7.jpg',
      '/resources/corredorb8.jpg',
      '/resources/corredorb9.jpg',
      '/resources/corredorb10.jpg'
      ],
    descripcion: {
      intro: 'Es un extenso parque que bordea el sector norte de la localidad, espacio que brinda al visitante un sector de asadores, mesas, sanitarios, juegos confeccionados en madera y con material reciclado, exposición de maquinarias antiguas, esculturas en metal y cemento, árboles nativos y el monumento en homenaje a Ex - Combatientes de Malvinas.',
    }
  },
  {
    id: 12,
    titulo: 'Instituto Educativo Santo Domingo',
    imagen: '/resources/pericota.JPG',
    descripcion: {
      intro: 'Hacia el extremo este podemos encontrar la antigua edificación que perteneciera al Ferrocarril, donde hoy se desarrollan las dos actividades del “Instituto Educativo Santo Domingo”: la parte educativa provee opciones a nivel secundario, terciario y educación secundaria para adultos; siendo una alternativa importante para los habitantes de Santo Domingo como también de localidades cercanas. El área productiva, forma parte del instituto, donde la escuela secundaria “Los Colonizadores” elabora diversos productos lácteos, siendo un lugar de capacitación para los futuros egresados (tanto del nivel secundario como de carreras terciarias como las tecnicaturas).',
    }
  },
  {
    id: 13,
    titulo: 'Bio - Parque Los Rieles',
    imagen: '/resources/dinos.webp',
      imagenes: ['/resources/Bioparque.jpg',
                '/resources/Bioparque2.jpg',
                '/resources/Bioparque3.jpg',
      ],
    descripcion: {
      intro: 'También se encuentra en el sector este del pueblo destacándose en él un grupo de esculturas de dinosaurios que habitaron nuestro país, realizados en cemento y rodeados por vegetación autóctona.',
    }
  },
   {
    id: 14,
    titulo: 'Zona Rural',
    imagen: '/resources/atalaya.jpg',
    descripcion: {
      intro: 'La zona rural de Santo Domingo es muy amplia, en todo el distrito de la localidad de Santo Domingo se contabilizan 27 tambos, los cuales constituyen el primer eslabón de la cadena en la industria láctea. El desarrollo de esta actividad produce diversos efectos positivos en la población y la economía local, en el empleo, movimientos migratorios, beneficios económicos, aparición de industrias auxiliares, renta per cápita, mejoras en el valor del suelo, entre otros. Por lo general, la materia prima que se extrae es llevada hacia las fábricas que se encuentran a una cercanía relativa de su origen; utilizando para ello una red simplificada de caminos rurales, estos confluyen a la Ruta Provincial Nº 4 y la Ruta 80 S.  Asimismo, la ruralidad permite visitar:',
      items: [
        'El Paraje “Los Préstamos”, donde la mano del hombre extrajo la tierra y luego la naturaleza se encargó de llenar las fosas con las aguas de desborde del Río Salado, arrastrando consigo fauna viva que antes no existía en la zona; por eso hoy se albergan en el lugar yacarés, carpinchos y otras especies que brindan una atracción muy especial.',
        'El Circuito “EL ARENOSO”, consecuencia de la extracción de arena que realizara la Empresa S.A.O.P.I.M. para la pavimentación de la Ruta N° 4. Así, se formó el circuito de tierra más reconocido en la región… Una pista que alberga en cada evento a muchas personas y brinda la posibilidad de observar espectáculos de automovilismo y motociclismo.  ',
        'La Estancia “La Atalaya”, cuyo casco fue construido en el año 1910 y realizado con materiales nacionales e importados, conservando hasta la actualidad su imponente belleza.',
        'El Río Salado, cuyas aguas constituyen el límite noreste del territorio santodominguense.  Allí, el paisaje es diverso, los árboles cambian sus formas y colores, están preparados para enfrentar el atropello de las crecidas, y soportar el agua salada que los baña.'
      ] 
    }
  },


];
const EspaciosPublicos = () => {
  const scrollRef = useRef(null);
  const [abierto, setAbierto] = useState(null);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const abrirModal = (espacio) => {
    setAbierto(espacio);
    setCurrentImgIndex(0);
  };

  const listaImagenes = abierto
  ? [abierto.imagen, ...(abierto.imagenes ?? [])]
  : [];

  const scrollLeft = () => {
    if (!scrollRef.current) return;
    const card = scrollRef.current.querySelector('.espacio-card');
    if (!card) return;

    const gap = 8; 
    scrollRef.current.scrollBy({
      left: -(card.offsetWidth + gap),
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    if (!scrollRef.current) return;
    const card = scrollRef.current.querySelector('.espacio-card');
    if (!card) return;

    const gap = 8;
    scrollRef.current.scrollBy({
      left: card.offsetWidth + gap,
      behavior: 'smooth',
    });
  };

  // 🔥 EFECTO PARA BLOQUEAR SCROLL DE FONDO (Con compensación de salto)
  useEffect(() => {
    if (abierto) {
      // 1. Calculamos el ancho del scrollbar del navegador
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // 2. Bloqueamos el scroll del body
      document.body.style.overflow = 'hidden';
      
      // 3. Agregamos padding derecho para evitar que la página "salte"
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      // Restauramos todo al cerrar
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    // Cleanup function: Asegura que se desbloquee si el componente se desmonta
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [abierto]);

  return (
    <section className="espacios-section" id="espaciosPublicos">
      {/* Título unificado con el resto de la página */}
      <h2 className="espacios-titulo-seccion">Lugares destacados de nuestra localidad</h2>

      <button className="scroll-btn left" onClick={scrollLeft} aria-label="Anterior">
        ‹
      </button>

      <div ref={scrollRef} className="espacios-container">
        {espacios.map((esp) => (
          <div key={esp.id} className="espacio-card">
            <div className="espacio-cara">
              <img className="espacio-imagen" src={esp.imagen} alt={esp.titulo} />

              <div className="espacio-barra">
                <h3 className="espacio-titulo">{esp.titulo}</h3>
                <button className="espacio-btn" onClick={() => abrirModal(esp)} aria-label="Ver más">
                  ▼
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="scroll-btn right" onClick={scrollRight} aria-label="Siguiente">
        ›
      </button>

      {/* MODAL */}
      {abierto && (
        <div className="espacio-modal" role="dialog" aria-modal="true">
          <div className="espacio-modal__backdrop" onClick={() => setAbierto(null)} />

          <div className="espacio-modal__panel" style={{ "--modal-bg": `url(${listaImagenes[currentImgIndex]})` }}>
            <button className="espacio-modal__close" onClick={() => setAbierto(null)}>
              ✕
            </button>

            {(() => {
              const listaImagenes = [abierto.imagen, ...(abierto.imagenes ?? [])];
              const hayThumbs = listaImagenes.length > 1;

              return (
                <>
                  {/* HERO */}
                  <div className="espacio-modal__heroWrap">
                    <img
                      className="espacio-modal__hero"
                      src={listaImagenes[currentImgIndex]}
                      alt={abierto.titulo}
                    />

                    {/* MINIATURAS ARRIBA SOBRE LA FOTO */}
                    {hayThumbs && (
                      <div className="espacio-modal__thumbnailsOver">
                        <div className="espacio-modal__thumbnailsTrack">
                          {listaImagenes.map((img, i) => (
                            <button
                              key={i}
                              type="button"
                              className={`espacio-modal__thumbBtn ${
                                i === currentImgIndex ? 'activo' : ''
                              }`}
                              onClick={() => setCurrentImgIndex(i)}
                              aria-label={`Foto ${i + 1}`}
                            >
                              <img
                                className="espacio-modal__thumbnail"
                                src={img}
                                alt={`${abierto.titulo} ${i + 1}`}
                              />
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* CONTENIDO (scrollea si hace falta) */}
                  <div className="espacio-modal__content">
                    <h3 className="espacio-modal__title">{abierto.titulo}</h3>

                    {abierto.descripcion?.intro && (
                      <p className="espacio-modal__desc">{abierto.descripcion.intro}</p>
                    )}

                    {Array.isArray(abierto.descripcion?.items) &&
                      abierto.descripcion.items.length > 0 && (
                        <ul className="espacio-modal__lista">
                          {abierto.descripcion.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      )}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </section>
  );
};

export default EspaciosPublicos;